import { createContext, KeyboardEvent } from 'react';
import {
  NavigableTreeNode,
  onLoadChildren as onLoadChildrenCallback,
} from '../types';

type TreeContextValue = {
  treeNodes: NavigableTreeNode[];
  handleKeyDown: (e: KeyboardEvent, node: NavigableTreeNode) => void;
  handleItemToggle: (node: NavigableTreeNode) => void;
  onLoadChildren: onLoadChildrenCallback;
  onSelectNode: (nodeId: number) => void;
  currentTreeNode: NavigableTreeNode | null;
  currentTreeNodePath: NavigableTreeNode[];
};

const TreeContext = createContext<TreeContextValue>({
  treeNodes: [],
  handleKeyDown: () => {},
  handleItemToggle: () => {},
  onLoadChildren: async () => [],
  onSelectNode: () => {},
  currentTreeNode: null,
  currentTreeNodePath: [],
});

export default TreeContext;
export { TreeContextValue };
